import { Injectable } from '@angular/core';

import { WindowService } from '../../shared/services/window.service';
import { ServiceWorkerMessage } from '../service-worker-message.model';
import { ServiceWorkerRegistrationHandler } from './service-worker-registration-handlers.injection-token';

// Keep in sync with `shell-and-config.warmup.ts`. We should bump the version if there are major changes in data contract, since
// an installing service worker might not have the same data contract as the app
export interface AuthorizedWarmupMessagePayloadV1 {
    token: string;
    userId: string;
    apiQsParams?: {[key: string] : string};
}

export interface AuthorizedWarmupMessagePayloadV2 extends AuthorizedWarmupMessagePayloadV1 {
    apiPath?: string;
}

export interface AuthorizedWarmupMessagePayloadV3 extends AuthorizedWarmupMessagePayloadV2 {
    apiHeaders?: { [key: string]: string };
}

export interface AuthorizedWarmupMessage extends ServiceWorkerMessage {
    type: 'OFFICECOM_AUTH_WARMUP';
    meta: 'installation-credentials';
    payload: AuthorizedWarmupMessagePayloadV2;
}

/**
 * Responsible for providing the Office.com Access Token to the installing worker for PWA so that Service Worker can complete installation
 */
@Injectable()
export abstract class ServiceWorkerAuthorizedInstallService implements ServiceWorkerRegistrationHandler {

    constructor (
        protected readonly windowService: WindowService
    ) {
    }

    public abstract async handleRegistration(registration: ServiceWorkerRegistration): Promise<void>;

    protected addParamFromWindow(payload: AuthorizedWarmupMessagePayloadV2, queryParam: string) {
        const parsedWindowUrl = new URL(this.windowService.nativeWindow.location.href);

        const valueOnWindow = parsedWindowUrl.searchParams.get(queryParam);
        if (!valueOnWindow) {
            return;
        }

        if (!payload.apiQsParams) {
            payload.apiQsParams = {
                [queryParam]: valueOnWindow
            };
        } else {
            payload.apiQsParams[queryParam] = valueOnWindow;
        }
    }
}
